(function() {
/*
    Injects an input field for filtering resorts based on `destinationAirport`.
    HTML for results is not injected to allow any UI implementation using `scope.resorts`.
*/
'use strict';

angular
    .module('searchUnit')
    .directive('resortField', function(searchUnitService, $filter, $rootScope, $timeout) {
        return {
            restrict: 'E',
            scope: {
                select: '&',
                deselect: '&',
                loadOnce: '=',
                currentValue: '=',
                placeholder: '@'
            },
            transclude: true,
            replace: true,
            templateUrl: 'partials/searchunit/resortfield',
            link(scope, el) {
                let currDest;
                const loadingClass = 'small-spinner';
                const inputField = el.find('.resort-input');

                // Props on scope
                scope.resorts = undefined;
                scope.allResorts = undefined;
                scope.resortInput = inputField;

                // Methods on scope
                scope.setResort = function(r) {
                    scope.resortTerm = r.Description;
                    scope.select({ item: r });
                };

                init(scope.loadOnce);


                function init(once) {
                    // Set any existing field value
                    const unwatchCurrent = scope.$watch('currentValue', v => {
                        if (v) {
                            if (!scope.resortTerm) {
                                scope.resortTerm = v.Description;
                            }
                            // Remove watch when value is found
                            unwatchCurrent();
                        }
                    });

                    // Filter resorts
                    scope.$watch('resortTerm', function(v) {
                        scope.resorts = filterResorts(v);

                        // If user cleared field that contained a value
                        if (!v && inputField.hasClass('ng-touched')) {
                            scope.deselect();
                        }
                    });

                    if (once) {
                        // Load resorts once only i.e. Mobile
                        // Timer ensures view has initialised
                        $timeout(updateResorts);
                    } else {
                        // Watch destination airport for changes
                        scope.$watch(
                            '$parent.destinationAirport',
                            v => { // Can't use `oldVal` because it doesn't refresh each `init()`
                                if (!v) { // No airport
                                    scope.allResorts =
                                    scope.resorts =
                                    scope.resortTerm =
                                    currDest = undefined;
                                } else if (!currDest || v.Title !== currDest.Title) {
                                    updateResorts();
                                    currDest = v;
                                }
                            }
                        );
                    }
                }

                function updateResorts() {
                    inputField.addClass(loadingClass);
                    fetchResorts().then(() => {
                        inputField.removeClass(loadingClass);
                    });
                }

                function fetchResorts() {
                    scope.allResorts =
                    scope.resorts = undefined;

                    return searchUnitService.getAvailableResorts()
                        .then(res => {
                                let resMatch;
                                const currTerm = scope.resortTerm;

                                scope.allResorts = // Keep a copy of all resorts
                                scope.resorts = res; // This will change to filtered results

                                // Re-select term if it exists in results
                                if (currTerm && _.some(res, o => {
                                    if (o.Description.toLowerCase() === currTerm.toLowerCase()) {
                                        resMatch = o;
                                        return true; // Quits at first match
                                    }
                                })) {
                                    scope.setResort(resMatch);
                                } else {
                                    scope.resortTerm = undefined;
                                }
                            }, msg => {
                                $rootScope.$broadcast('flash:error', msg);
                            });
                }

                function filterResorts(str) {
                    // Equivalent to 'allResorts|filter:str|limitTo:30'
                    return $filter('limitTo')(
                                $filter('filter')(scope.allResorts, str),
                           30);
                }
            }
        };
    });
})();
